import { iaRa } from 'lib/helpers/utility';

const getServicesName = (services) => {
  const serviceNames = iaRa(services).map((it) => it.name);
  return serviceNames.join(', ');
};

export default getServicesName;
